import React from 'react';
import { 
  FaUser, 
  FaCalendar, 
  FaEdit, 
  
  FaCamera,  
  FaEnvelope,
  FaPhone,
  FaBirthdayCake,
  FaBriefcase,
  FaGlobe,
  FaCode,
  FaLaptopCode,
  FaAward,
  FaTools,
  FaRegClock,
  FaUsers,
} from 'react-icons/fa';
import './developer.css';

const DeveloperPageProfilepage = () => {
  return (
    <div className="developer-profile-container single-column" style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", maxWidth: '1200px', margin: '0 auto', padding: '20px' }}>
      {/* Profile Header Section */}
     <div className="profile-header" style={{
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: '30px',
    padding: '30px',
    borderRadius: '10px',
    background: 'linear-gradient(135deg, rgba(245,247,250,0.9) 0%, rgba(195,207,226,0.9) 100%), url("https://example.com/your-background-image.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    position: 'relative'
}}>
    {/* Rest of your existing code remains the same */}
    <div className="avatar-container" style={{
        width: '150px',
        height: '150px',
        borderRadius: '50%',
        border: '5px solid white',
        boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
        marginBottom: '20px',
        overflow: 'hidden',
        position: 'relative'
    }}>
        <img 
            src="https://randomuser.me/api/portraits/women/44.jpg" 
            alt="Profile" 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
        <div className="camera-icon" style={{
            position: 'absolute',
            bottom: '10px',
            right: '10px',
            background: '#4CC5CD',
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            cursor: 'pointer'
        }}>
            {/* Assuming you have FontAwesome imported for FaCamera */}
            <FaCamera />
        </div>
    </div>
    
    <h1 style={{ 
        margin: '10px 0 5px',
        fontSize: '2.2rem',
        color: '#333',
        fontWeight: '600'
    }}>Jessica Smith</h1>
    
    <p style={{
        color: '#4CC5CD',
        fontSize: '1.1rem',
        fontWeight: '500',
        marginBottom: '15px'
    }}>Senior UI/UX Designer</p>
</div>

      {/* About Section */}
      <div className="panel about-panel" style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        marginBottom: '30px',
        overflow: 'hidden'
      }}>
        <div className="panel-heading" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          borderBottom: '1px solid #eee',
          background: '#f9fafc'
        }}>
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            margin: '0',
            fontSize: '1.3rem',
            color: '#333'
          }}><FaUser style={{ color: '#e06b7d' }} /> About Me</h2>
          <button className="btn btn-edit" style={{
            display: 'flex',
            alignItems: 'center',
            gap: '5px',
            background: '#4CC5CD',
            color: 'white',
            border: 'none',
            padding: '8px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'all 0.3s'
          }}><FaEdit /> Edit</button>
        </div>
        <div className="panel-body" style={{ padding: '20px' }}>
          <p className="about-text" style={{
            color: '#555',
            lineHeight: '1.6',
            marginBottom: '25px',
            fontSize: '0.95rem'
          }}>
            Creative UI/UX designer with 8+ years of experience designing and developing user-centered digital experiences. 
            Passionate about creating intuitive and engaging interfaces that improve user satisfaction and drive business growth.
            Specialized in responsive web design, mobile applications, and design systems.
          </p>
          
          <div className="personal-info-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
            gap: '20px'
          }}>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaEnvelope className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#e06b7d',
                background: 'rgba(224, 107, 125, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Email</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>jsmith@flatlab.com</p>
              </div>
            </div>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaPhone className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#4CC5CD',
                background: 'rgba(76, 197, 205, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Phone</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>(12) 03 4567890</p>
              </div>
            </div>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaBirthdayCake className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#96be4b',
                background: 'rgba(150, 190, 75, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Birthday</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>13 July 1983</p>
              </div>
            </div>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaBriefcase className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#cba4db',
                background: 'rgba(203, 164, 219, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Experience</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>8+ Years</p>
              </div>
            </div>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaGlobe className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#f4b350',
                background: 'rgba(244, 179, 80, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Location</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>Sydney, Australia</p>
              </div>
            </div>
            <div className="info-item" style={{
              display: 'flex',
              gap: '15px',
              alignItems: 'center'
            }}>
              <FaTools className="info-icon" style={{
                fontSize: '1.3rem',
                color: '#5d9cec',
                background: 'rgba(93, 156, 236, 0.1)',
                padding: '12px',
                borderRadius: '50%'
              }} />
              <div>
                <h5 style={{ margin: '0 0 5px', fontSize: '0.85rem', color: '#888', fontWeight: '500' }}>Tools</h5>
                <p style={{ margin: '0', fontSize: '0.95rem', fontWeight: '500', color: '#333' }}>Figma, Adobe XD, Sketch</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skills Section */}
      <div className="panel skills-panel" style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        marginBottom: '30px',
        overflow: 'hidden'
      }}>
        <div className="panel-heading" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          borderBottom: '1px solid #eee',
          background: '#f9fafc'
        }}>
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            margin: '0',
            fontSize: '1.3rem',
            color: '#333'
          }}><FaLaptopCode style={{ color: '#4CC5CD' }} /> Technical Skills</h2>
        </div>
        <div className="panel-body" style={{ padding: '20px' }}>
          <div className="skill-item" style={{ marginBottom: '20px' }}>
            <div className="skill-info" style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px',
              fontSize: '0.9rem'
            }}>
              <span style={{ fontWeight: '500' }}>UI/UX Design</span>
              <span style={{ color: '#888' }}>90%</span>
            </div>
            <div className="progress" style={{
              height: '8px',
              background: '#f1f1f1',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div className="progress-bar" style={{
                width: '90%',
                height: '100%',
                background: '#e06b7d',
                borderRadius: '4px',
                transition: 'width 1s ease-in-out'
              }}></div>
            </div>
          </div>
          <div className="skill-item" style={{ marginBottom: '20px' }}>
            <div className="skill-info" style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px',
              fontSize: '0.9rem'
            }}>
              <span style={{ fontWeight: '500' }}>HTML/CSS</span>
              <span style={{ color: '#888' }}>85%</span>
            </div>
            <div className="progress" style={{
              height: '8px',
              background: '#f1f1f1',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div className="progress-bar" style={{
                width: '85%',
                height: '100%',
                background: '#4CC5CD',
                borderRadius: '4px',
                transition: 'width 1s ease-in-out'
              }}></div>
            </div>
          </div>
          <div className="skill-item" style={{ marginBottom: '20px' }}>
            <div className="skill-info" style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px',
              fontSize: '0.9rem'
            }}>
              <span style={{ fontWeight: '500' }}>JavaScript</span>
              <span style={{ color: '#888' }}>75%</span>
            </div>
            <div className="progress" style={{
              height: '8px',
              background: '#f1f1f1',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div className="progress-bar" style={{
                width: '75%',
                height: '100%',
                background: '#96be4b',
                borderRadius: '4px',
                transition: 'width 1s ease-in-out'
              }}></div>
            </div>
          </div>
          <div className="skill-item" style={{ marginBottom: '20px' }}>
            <div className="skill-info" style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px',
              fontSize: '0.9rem'
            }}>
              <span style={{ fontWeight: '500' }}>React</span>
              <span style={{ color: '#888' }}>80%</span>
            </div>
            <div className="progress" style={{
              height: '8px',
              background: '#f1f1f1',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div className="progress-bar" style={{
                width: '80%',
                height: '100%',
                background: '#cba4db',
                borderRadius: '4px',
                transition: 'width 1s ease-in-out'
              }}></div>
            </div>
          </div>
          <div className="skill-item" style={{ marginBottom: '20px' }}>
            <div className="skill-info" style={{
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '8px',
              fontSize: '0.9rem'
            }}>
              <span style={{ fontWeight: '500' }}>Figma</span>
              <span style={{ color: '#888' }}>95%</span>
            </div>
            <div className="progress" style={{
              height: '8px',
              background: '#f1f1f1',
              borderRadius: '4px',
              overflow: 'hidden'
            }}>
              <div className="progress-bar" style={{
                width: '95%',
                height: '100%',
                background: '#f4b350',
                borderRadius: '4px',
                transition: 'width 1s ease-in-out'
              }}></div>
            </div>
          </div>
        </div>
      </div>

      {/* Projects Section */}
      <div className="panel projects-panel" style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        marginBottom: '30px',
        overflow: 'hidden'
      }}>
        <div className="panel-heading" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          borderBottom: '1px solid #eee',
          background: '#f9fafc'
        }}>
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            margin: '0',
            fontSize: '1.3rem',
            color: '#333'
          }}><FaCode style={{ color: '#96be4b' }} /> Current Projects</h2>
          <button className="btn btn-view-all" style={{
            background: 'transparent',
            color: '#4CC5CD',
            border: '1px solid #4CC5CD',
            padding: '8px 15px',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: '500',
            transition: 'all 0.3s'
          }}>View All Projects</button>
        </div>
        <div className="panel-body" style={{ padding: '20px' }}>
          <div className="project-card" style={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #eee',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="project-header" style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <div className="project-chart" style={{
                marginRight: '20px',
                position: 'relative',
                width: '60px',
                height: '60px'
              }}>
                <svg viewBox="0 0 36 36" style={{
                  width: '100%',
                  height: '100%',
                  transform: 'rotate(-90deg)'
                }}>
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#f1f1f1"
                    strokeWidth="3"
                    strokeDasharray="100, 100"
                  />
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#e06b7d"
                    strokeWidth="3"
                    strokeDasharray="35, 100"
                  />
                </svg>
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#e06b7d'
                }}>5%</div>
              </div>
              <div className="project-title">
                <h4 style={{ margin: '0 0 5px', fontSize: '1.1rem' }}>Envato Website</h4>
                <span className="badge badge-danger" style={{
                  background: 'rgba(224, 107, 125, 0.1)',
                  color: '#e06b7d',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>UI Design</span>
              </div>
            </div>
            <div className="project-details">
              <p style={{
                color: '#666',
                fontSize: '0.9rem',
                lineHeight: '1.6',
                marginBottom: '15px'
              }}>Redesigning the main website with modern UI components and improved user flow.</p>
              <div className="project-meta" style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px',
                fontSize: '0.8rem',
                color: '#888'
              }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaCalendar /> 15 July - 15 Aug</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaUsers /> 4 Members</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaRegClock /> 35% completed</span>
              </div>
            </div>
          </div>
          
          <div className="project-card" style={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #eee',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="project-header" style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <div className="project-chart" style={{
                marginRight: '20px',
                position: 'relative',
                width: '60px',
                height: '60px'
              }}>
                <svg viewBox="0 0 36 36" style={{
                  width: '100%',
                  height: '100%',
                  transform: 'rotate(-90deg)'
                }}>
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#f1f1f1"
                    strokeWidth="3"
                    strokeDasharray="100, 100"
                  />
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#4CC5CD"
                    strokeWidth="3"
                    strokeDasharray="63, 100"
                  />
                </svg>
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#4CC5CD'
                }}>63%</div>
              </div>
              <div className="project-title">
                <h4 style={{ margin: '0 0 5px', fontSize: '1.1rem' }}>ThemeForest CMS</h4>
                <span className="badge badge-info" style={{
                  background: 'rgba(76, 197, 205, 0.1)',
                  color: '#4CC5CD',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>Development</span>
              </div>
            </div>
            <div className="project-details">
              <p style={{
                color: '#666',
                fontSize: '0.9rem',
                lineHeight: '1.6',
                marginBottom: '15px'
              }}>Building a custom CMS for theme authors with advanced customization options.</p>
              <div className="project-meta" style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px',
                fontSize: '0.8rem',
                color: '#888'
              }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaCalendar /> 15 July - 15 Aug</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaUsers /> 6 Members</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaRegClock /> 63% completed</span>
              </div>
            </div>
          </div>
          
          <div className="project-card" style={{
            display: 'flex',
            flexDirection: 'column',
            border: '1px solid #eee',
            borderRadius: '8px',
            padding: '20px',
            marginBottom: '20px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="project-header" style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: '15px'
            }}>
              <div className="project-chart" style={{
                marginRight: '20px',
                position: 'relative',
                width: '60px',
                height: '60px'
              }}>
                <svg viewBox="0 0 36 36" style={{
                  width: '100%',
                  height: '100%',
                  transform: 'rotate(-90deg)'
                }}>
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#f1f1f1"
                    strokeWidth="3"
                    strokeDasharray="100, 100"
                  />
                  <path
                    d="M18 2.0845
                      a 15.9155 15.9155 0 0 1 0 31.831
                      a 15.9155 15.9155 0 0 1 0 -31.831"
                    fill="none"
                    stroke="#96be4b"
                    strokeWidth="3"
                    strokeDasharray="75, 100"
                  />
                </svg>
                <div style={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  color: '#96be4b'
                }}>75%</div>
              </div>
              <div className="project-title">
                <h4 style={{ margin: '0 0 5px', fontSize: '1.1rem' }}>VectorLab Portfolio</h4>
                <span className="badge badge-success" style={{
                  background: 'rgba(150, 190, 75, 0.1)',
                  color: '#96be4b',
                  padding: '3px 10px',
                  borderRadius: '20px',
                  fontSize: '0.75rem',
                  fontWeight: '500'
                }}>UX Research</span>
              </div>
            </div>
            <div className="project-details">
              <p style={{
                color: '#666',
                fontSize: '0.9rem',
                lineHeight: '1.6',
                marginBottom: '15px'
              }}>Creating a portfolio platform for designers with AI-powered layout suggestions.</p>
              <div className="project-meta" style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '15px',
                fontSize: '0.8rem',
                color: '#888'
              }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaCalendar /> 15 July - 15 Aug</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaUsers /> 3 Members</span>
                <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}><FaRegClock /> 75% completed</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Certifications Section */}
      <div className="panel certifications-panel" style={{
        background: 'white',
        borderRadius: '10px',
        boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
        marginBottom: '30px',
        overflow: 'hidden'
      }}>
        <div className="panel-heading" style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '20px',
          borderBottom: '1px solid #eee',
          background: '#f9fafc'
        }}>
          <h2 style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            margin: '0',
            fontSize: '1.3rem',
            color: '#333'
          }}><FaAward style={{ color: '#f4b350' }} /> Certifications</h2>
        </div>
        <div className="panel-body" style={{ padding: '20px' }}>
          <div className="certification-card" style={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
            border: '1px solid #eee',
            borderRadius: '8px',
            marginBottom: '15px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="certification-badge" style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'rgba(244, 179, 80, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
              flexShrink: '0',
              color: '#f4b350',
              fontSize: '1.2rem'
            }}>
              <FaAward />
            </div>
            <div className="certification-content">
              <h4 style={{ margin: '0 0 5px', fontSize: '1rem' }}>UX Certification</h4>
              <p style={{ margin: '0 0 5px', color: '#666', fontSize: '0.9rem' }}>Nielsen Norman Group</p>
              <div className="certification-date" style={{
                color: '#888',
                fontSize: '0.8rem'
              }}>2018</div>
            </div>
          </div>
          
          <div className="certification-card" style={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
            border: '1px solid #eee',
            borderRadius: '8px',
            marginBottom: '15px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="certification-badge" style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'rgba(244, 179, 80, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
              flexShrink: '0',
              color: '#f4b350',
              fontSize: '1.2rem'
            }}>
              <FaAward />
            </div>
            <div className="certification-content">
              <h4 style={{ margin: '0 0 5px', fontSize: '1rem' }}>Frontend Development</h4>
              <p style={{ margin: '0 0 5px', color: '#666', fontSize: '0.9rem' }}>freeCodeCamp</p>
              <div className="certification-date" style={{
                color: '#888',
                fontSize: '0.8rem'
              }}>2016</div>
            </div>
          </div>
          
          <div className="certification-card" style={{
            display: 'flex',
            alignItems: 'center',
            padding: '15px',
            border: '1px solid #eee',
            borderRadius: '8px',
            marginBottom: '15px',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}>
            <div className="certification-badge" style={{
              width: '50px',
              height: '50px',
              borderRadius: '50%',
              background: 'rgba(244, 179, 80, 0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginRight: '15px',
              flexShrink: '0',
              color: '#f4b350',
              fontSize: '1.2rem'
            }}>
              <FaAward />
            </div>
            <div className="certification-content">
              <h4 style={{ margin: '0 0 5px', fontSize: '1rem' }}>Accessibility Fundamentals</h4>
              <p style={{ margin: '0 0 5px', color: '#666', fontSize: '0.9rem' }}>W3C</p>
              <div className="certification-date" style={{
                color: '#888',
                fontSize: '0.8rem'
              }}>2020</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeveloperPageProfilepage;